import React, { useEffect } from "react";
import styles from "../paymentSection/paymentSection.module.scss";
import Payment from "../../components/payment/Payment";
import EasySteps from "../../components/easySteps/EasySteps";
import CommonQuestions from "../../components/commonQuestions/CommonQuestions";
import Contact from "../../components/contact/Contact";
import Footer from "../footer/Footer";
import ServicesProvided from "../../components/reusable/servicesProvided/ServicesProvided";
import Navbar from "../../components/navbar/Navbar";

const data = [
  {
    id: 1,
    question: "How do I integrate a payment gateway into my application?",
    answer:
      "A domain is your unique identity on the internet. It helps user to find out your website or application easily.",
  },
  {
    id: 2,
    question: "Is there a transaction fee for payment gateways?",
    answer:
      "A domain is your unique identity on the internet. It helps user to find out your website or application easily.",
  },
  {
    id: 3,
    question: "How can I use SMS services to verify user accounts?",
    answer:
      "A domain is your unique identity on the internet. It helps user to find out your website or application easily.",
  },
  {
    id: 4,
    question: "Can I automate payment refunds?",
    answer:
      "A domain is your unique identity on the internet. It helps user to find out your website or application easily.",
  },
];

const PaymentSection = () => {
  useEffect(() => {
    const section = document.getElementById("services");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

  return (
    <div className={styles.container}>
      <Navbar />
      <Payment id="services" />
      <ServicesProvided />
      <EasySteps />
      <CommonQuestions questioData={data} />
      <Contact />
      <Footer />
    </div>
  );
};

export default PaymentSection;
